import { cn } from '../lib/utils';

interface Props {
  className?: string;
}

/** Leyenda para formularios/modales con campos obligatorios marcados con asterisco. */
export function RequiredFieldsLegend({ className }: Props) {
  return (
    <p className={cn('text-xs text-muted-foreground', className)}>
      Los campos marcados con <span className="text-destructive font-medium">*</span> son obligatorios.
    </p>
  );
}
